import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getNotificationList = createAsyncThunk(
  "notificationList/getNotificationList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/notification/get_all_data`,
        data,

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const notificationSlice = createSlice({
  name: "notificationList",
  initialState: {
    loading: false,
    notificationData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNotificationList.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationData = action.payload;
      })
      .addCase(getNotificationList.rejected, (state, action) => {
        state.loading = false;
        state.notificationData = action.payload;
        state.error = action.payload;
      });
  },
});

export default notificationSlice.reducer;
